// panel-web/src/pages/configuracion/Recursos.jsx
import { useEffect, useState } from 'react';
import api from '../../api/client';
import { useFincaId } from '../../context/FincaContext';

export default function Recursos() {
  const fincaId = useFincaId();
  const [items, setItems]       = useState([]);
  const [cargando, setCargando] = useState(true);
  const [mensaje, setMensaje]   = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm]         = useState({ nombre: '', gramos_segundo: '' });

  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, [fincaId]);

  const cargar = async () => {
    setCargando(true);
    try {
      const { data } = await api.get('/tipos-balanceado');
      setItems(data || []);
    } catch (err) {
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || 'Error al cargar' });
    } finally {
      setCargando(false);
    }
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ nombre: '', gramos_segundo: '' });
    setMostrarModal(true);
  };

  const abrirEditar = (it) => {
    setEditando(it);
    setForm({
      nombre: it.nombre || '',
      gramos_segundo: it.gramos_segundo ?? '',
    });
    setMostrarModal(true);
  };

  const guardar = async (e) => {
    e.preventDefault();
    setMensaje(null);
    try {
      const payload = {
        nombre: form.nombre.trim(),
        gramos_segundo: form.gramos_segundo === '' ? 0 : parseFloat(form.gramos_segundo),
      };
      if (editando) {
        await api.put(`/tipos-balanceado/${editando.id}`, payload);
      } else {
        await api.post('/tipos-balanceado', payload);
      }
      setMostrarModal(false);
      await cargar();
      setMensaje({ tipo: 'ok', texto: editando ? 'Actualizado' : 'Creado' });
      setTimeout(() => setMensaje(null), 1500);
    } catch (err) {
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || 'Error al guardar' });
    }
  };

  const eliminar = async (it) => {
    if (!confirm(`¿Eliminar "${it.nombre}"?`)) return;
    try {
      await api.delete(`/tipos-balanceado/${it.id}`);
      await cargar();
      setMensaje({ tipo: 'ok', texto: 'Eliminado' });
      setTimeout(() => setMensaje(null), 1500);
    } catch {
      setMensaje({ tipo: 'error', texto: 'Error al eliminar' });
    }
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <div>
          <h2 className="text-xl font-bold text-primary">🧰 Recursos — Tipos de balanceado</h2>
          <p className="text-xs text-gray-500">
            Catálogo de alimentos que se usarán en el Registro Biólogo.
          </p>
        </div>
        <button onClick={abrirNuevo}
          className="px-4 py-2 bg-primary text-white rounded text-sm hover:bg-blue-800">
          + Nuevo balanceado
        </button>
      </div>

      {mensaje && (
        <div className={`mb-3 p-2 rounded text-sm ${
          mensaje.tipo === 'ok' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
        }`}>
          {mensaje.texto}
        </div>
      )}

      {cargando ? (
        <div className="bg-white p-6 rounded shadow text-center text-gray-500">Cargando...</div>
      ) : items.length === 0 ? (
        <div className="bg-white p-6 rounded shadow text-center text-gray-500">
          No hay balanceados registrados. Crea el primero con el botón de arriba.
        </div>
      ) : (
        <div className="bg-white rounded shadow overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-left px-3 py-2 font-semibold">Nombre del balanceado</th>
                <th className="text-right px-3 py-2 font-semibold">Gramos / segundo</th>
                <th className="text-right px-3 py-2 font-semibold w-40">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id} className="border-t hover:bg-gray-50">
                  <td className="px-3 py-2">{it.nombre}</td>
                  <td className="px-3 py-2 text-right">{Number(it.gramos_segundo).toFixed(3)}</td>
                  <td className="px-3 py-2 text-right whitespace-nowrap">
                    <button onClick={() => abrirEditar(it)}
                      className="text-blue-600 hover:underline text-xs mr-3">Editar</button>
                    <button onClick={() => eliminar(it)}
                      className="text-red-600 hover:underline text-xs">Eliminar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {mostrarModal && (
        <div className="fixed inset-0 md:left-64 z-[9999] flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(75,85,99,0.6)', backdropFilter: 'blur(8px)' }}>
          <div className="bg-white rounded-2xl w-full max-w-md"
            style={{ border: '2px solid #0D47A1', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)' }}>
            <div className="px-5 py-4 text-white"
              style={{ background: 'linear-gradient(to right, #0D47A1, #1565C0)' }}>
              <h3 className="text-sm font-bold">
                {editando ? 'Editar balanceado' : 'Nuevo balanceado'}
              </h3>
            </div>
            <form onSubmit={guardar} className="p-5 space-y-3">
              <label className="block">
                <span className="text-xs text-gray-500">Nombre del balanceado</span>
                <input type="text" value={form.nombre} required
                  onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                  placeholder="Ej. Masterline #5"
                  className="mt-1 w-full px-3 py-2 border rounded text-sm" />
              </label>
              <label className="block">
                <span className="text-xs text-gray-500">Gramos / segundo</span>
                <input type="number" step="0.001" min="0"
                  value={form.gramos_segundo}
                  onChange={(e) => setForm({ ...form, gramos_segundo: e.target.value })}
                  placeholder="0.000"
                  className="mt-1 w-full px-3 py-2 border rounded text-sm" />
              </label>
              <div className="flex justify-end gap-2 pt-2">
                <button type="button" onClick={() => setMostrarModal(false)}
                  className="px-4 py-1.5 rounded border text-sm">Cancelar</button>
                <button type="submit"
                  className="px-4 py-1.5 text-white rounded text-sm"
                  style={{ backgroundColor: '#0D47A1' }}>
                  {editando ? 'Guardar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}